import React, { useState, useEffect } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";

// import page components
import ModernTradeNewTableView from "./ModernTradeNewTableView";
import ModernTradeNewSidebar from "./ModernTradeNewSidebar";

// import header footer components
import Header from "../../../compnents/Header";
import Footer from "../../../compnents/Footer";

// import data for table (api data)
import dataTableBody from "../../../api/Tabledata.json";

// Main component for filter and search functionality
function ViewTableFilterSearch(props) {
  const [filterOption, setFilterOption] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [check, setCheck] = useState(true);

  const { title = "Report", headers = [], data = []} = props;
  
  useEffect(() => {
    // Enable only if all 3 fields are filled
    if (filterOption && dateFrom && dateTo) {
      setIsSubmitDisabled(false);
      setCheck(false)
    } else {
      setIsSubmitDisabled(true);
    }
  }, [filterOption, dateFrom, dateTo]);

  // for table data exzample
  const dataTableHeaders = ["Firstname", "Lastname", "Email"];

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-2">
            <ModernTradeNewSidebar />
          </div>
          <div className="col-md-10">
            <div className="date-picker-area">
              <Form>
                <Row className="row-md-nowrap">
                  <Col lg={3} md={3} sm={3} xs={6}>
                    <Form.Select
                      name="filter_option"
                      className="form-control"
                      value={filterOption}
                      onChange={(e) => setFilterOption(e.target.value)}
                    >
                      <option value="">Select Option</option>
                      <option value="table_1">Table 1</option>
                      <option value="table_2">Table 2</option>
                      <option value="table_3">Table 3</option>
                      <option value="table_4">Table 4</option>
                    </Form.Select>
                  </Col>
                  <Col lg={3} md={3} sm={3} xs={6}>
                    <Form.Control
                      type="date"
                      name="date_from"
                      placeholder="Date from"
                      value={dateFrom}
                      onChange={(e) => setDateFrom(e.target.value)}
                    />
                  </Col>
                  <Col lg={3} md={3} sm={3} xs={6}>
                    <Form.Control
                      type="date"
                      name="date_to"
                      placeholder="Date to"
                      value={dateTo}
                      onChange={(e) => setDateTo(e.target.value)}
                    />
                  </Col>
                  <Col lg={3} md={3} sm={3} xs={6}>
                    <div className="d-flex justify-content-between">
                      <Button
                        type="button"
                        className="btn btn-dotconnect d-inline"
                        id="filter_search"
                        disabled={isSubmitDisabled}>
                        Submit
                      </Button>
                      <Button
                        type="button"
                        className="btn btn-dotconnect d-inline" style={{ marginLeft: "10px", width: "40px" }}
                        id="download_report"
                      ><span class="glyphicon glyphicon-download-alt"></span></Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </div>
            <ModernTradeNewTableView title="Report" 
                        headers={dataTableHeaders} 
                        data={dataTableBody} 
                        enableDownload={false}
                        check={check} />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ViewTableFilterSearch;
